import { SelectPortal, SelectViewport } from '@radix-ui/react-select';
import { ChevronUpIcon } from 'lucide-react';
import { FC } from 'react';
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectScrollDownButton,
  SelectTrigger,
  SelectValue,
} from './select';

interface Props {
  items: { label: string; value: string }[];
  onChange: (val: string) => void;
  placeholder?: string;
  defaultValue?: string;
}

const SelectForm: FC<Props> = ({
  items,
  onChange,
  placeholder,
  defaultValue,
}) => {
  return (
    <Select onValueChange={onChange} defaultValue={defaultValue}>
      <SelectTrigger aria-label="Mortgage Company">
        <SelectValue placeholder={placeholder || 'Select...'} />
      </SelectTrigger>
      <SelectPortal>
        <SelectContent>
          <SelectScrollDownButton>
            <ChevronUpIcon />
          </SelectScrollDownButton>
          <SelectViewport>
            <SelectGroup>
              {items.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectViewport>
        </SelectContent>
      </SelectPortal>
    </Select>
  );
};

export default SelectForm;
